import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Tags from '../images/tag.svg'
import Smile from '../images/smile.svg'
import SocialShare from '../components/SocialShare/SocialShare.jsx'
import Disqus from '../components/Disqus/Disqus.jsx'
import PrevNext from '../components/PrevNext/PrevNext.jsx'
import Author from '../components/Author/Author.jsx'
import SEO from '../components/SEO/Seo.jsx'
import Announcement from '../components/Announcement/Announcement.jsx'
class Template extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { data, pathContext } = this.props
    const { markdownRemark: post } = data
    const { siteMetadata: siteData } = data.site
    const { frontmatter, html } = post
    const { title, date } = frontmatter
    const { next, prev } = pathContext
    const postData = data.markdownRemark
    return (
      <div>
        <Helmet>
          <title>{`${title} - ${data.site.siteMetadata.title}`}</title>
          <link
            rel="canonical"
            href={`${data.site.siteMetadata.siteUrl}${frontmatter.path}`}
          />
        </Helmet>
        <SEO postPath={frontmatter.path} postNode={postData} siteMetadata={data.site.siteMetadata} postSEO />
        <div className="post-wrapper animated fadeIn">
          <div className="post-image">
            <h1>
              {frontmatter.title}
              <div className="post-metadata">
                by <Link to="/about">{data.site.siteMetadata.author}</Link> -{' '}
                {date}
              </div>
            </h1>
          </div>
          <div className="main-wrapper">
            <div className="content">
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
            <div className="tag-list">
              <ul>
                <li>
                  <img src={Tags} alt="" />
                </li>
                {frontmatter.tags.map(tag => {
                  return (
                    <li key={tag}>
                      <Link to={`/tags/${tag}`} className="a-animation">
                        {tag}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div>
              <SocialShare
                postPath={`${siteData.siteUrl}${frontmatter.path}`}
                postData={postData}
                hashTags={frontmatter.tags}
              />
            </div>
            <div className="subtitle content">
              enjoyed the article?
              <img src={Smile} alt="Phanor Coll" />
              <Link to="/contact" className="a-animation">
                contact me
              </Link>{' '}
              and lets bring your ideas to life.
            </div>
            <Announcement />
            <Author>
              With more than 20 years of experience, I love to learn every day,
              hack around and bring crazy ideas to life. Currently immersed in
              the world of <span className="standout">Go(golang)</span>,{' '}
              <span className="standout">Graph databases(Neo4j, Dgraph)</span>{' '}
              and <span className="standout">Rectjs</span>.
            </Author>
            <PrevNext prev={prev} next={next} />
            <Disqus
              shortname={siteData.disqusShortname}
              title={frontmatter.title}
              identifier={this.props.location.pathname}
              url={`${siteData.siteUrl}${frontmatter.path}`}
            />
          </div>
        </div>
      </div>
    )
  }
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        path
        tags
        excerpt
        featuredImage {
              childImageSharp {
                sizes {
                  ...GatsbyImageSharpSizes
                }
              }
            }
      }
    }
    site {
      siteMetadata {
        title
        author
        siteUrl
        disqusShortname
        twitter
        facebookAppId
      }
    }
  }
`

export default Template



// WEBPACK FOOTER //
// ./src/templates/blog-post.js